import "angular";
import ExtendCharBasedTruncationFactory from "./ExtendCharBasedTruncationFactory";
import ShowMoreOrLessDirective from "./ShowMoreOrLessDirective";
import ShowMoreOrLessValidationFactory from "./ShowMoreOrLessValidationFactory";
import WordBasedTruncationFactory from "./WordBasedTruncationFactory";

const moduleName = "ShowMoreOrLessModule";
const moduleDependencies = [];

const ShowMoreOrLessModule = angular
    .module(moduleName, moduleDependencies)
    .directive("showMoreOrLess", ShowMoreOrLessDirective)
    .factory("showMoreOrLessValidationFactory", ShowMoreOrLessValidationFactory)
    .factory("wordBasedTruncationFactory", WordBasedTruncationFactory)
    .factory("extendCharBasedTruncationFactory", ExtendCharBasedTruncationFactory);

export default ShowMoreOrLessModule;
